// extracted by mini-css-extract-plugin
export default {"buttonActive":"buttonSwitch_buttonActive__xgo7M","buttonDisabled":"buttonSwitch_buttonDisabled__hvWbS"};